import $axios from '~/plugins/axios';
import { buildModule } from '../utils';
import { Api, Tag, TagRequest } from '~/api';
import { Dict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withState({
		storedTags: {} as Dict<Tag>,
	})
	.withGetters({
		byId: state => (tagId: Tag['id']): Tag | null => (
			state.storedTags[tagId] ?? null
		),
	})
	.withMutations({
		STORE_TAG (state, tag: Tag) {
			state.storedTags = {
				...state.storedTags,
				[tag.id]: tag,
			};
		},
	})
	.withActions({
		async get ({ commit }, id: Tag['id']) {
			const { data } = await api.get(`/setting/tag/${ id }`);

			commit('STORE_TAG', data.payload);
		},
		async post ({ commit }, tag: TagRequest): Promise<Tag> {
			const { data } = await api.post('/setting/tag', tag);

			commit('STORE_TAG', data.payload);

			return data.payload;
		},
		async update ({ commit }, { id, ...body }: {
			id: Tag['id'];
		} & TagRequest) {
			const { data } = await api.put(`/setting/tag/${ id }`, body);

			commit('STORE_TAG', data.payload);
		},
	});
